<template>
  <HomeCard v-if="statistic">
    <CardHeader title="Thống kê" icon="fas fa-chart-pie" />
    <el-row>
      <el-col :span="12">
        <NumberInfo label="tổng số tài liệu" :number="statistic.totalDocument"/>
      </el-col>
      <el-col :span="12">
        <NumberInfo label="tài liệu đã kiểm tra" :number="statistic.completedDocumentCount"/>
      </el-col>
      <el-col :span="12">
        <NumberInfo label="tài liệu đang xử lý" :number="statistic.processingDocumentCount"/>
      </el-col>
      <el-col :span="12">
        <NumberInfo label="tài liệu đã xóa" :number="statistic.deletedDocumentCount"/>
      </el-col>
    </el-row>
  </HomeCard>
</template>

<script>
import { mapState } from "vuex"
import { AUTHENTICATE_STORE } from "@/store/modules/AuthenticateStore.js"
import VePie from "v-charts/lib/pie.common"
import CardHeader from "@/components/HomeComponents/CardHeader.vue"
import HomeCard from "@/components/HomeComponents/HomeCard.vue"
import NumberInfo from '@/components/HomeComponents/NumberInfo.vue'
import {apiGetDocumentStatistic} from '@/services/document_management_service.js'
export default {
  name: "DocumentStatistic",
  components: {NumberInfo, HomeCard, CardHeader, VePie },
  data(){
    return {
      statistic: null,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    }),
    chartData() {
      if (!this.user) return []
      return {
        columns: ["label", "percent"],
        rows: [
          { label: "Số trang còn lại", percent: this.user.credit.credit },
          { label: "Số page đã sử dụng", percent: this.user.subscription.plan.maxCreditPerday },
        ],
      }
    },
  },
  async mounted() {
    this.statistic = await apiGetDocumentStatistic()
  }
}
</script>
<style lang="scss" scoped>

</style>
